import axios from "axios";

class ServiceError extends Error {
  constructor(error, message, code, data) {
    super(message);
    this.error = error
    this.code = code;
    this.data = data;
    this.name = "ServiceError";
  }
}

const service = axios.create();

service.interceptors.request.use(
  (config) => {
    return config;
  },
  async (error) => {
    throw new ServiceError(error, error.message, "REQUEST_ERROR");
  }
);

const handleFileDownload = (blob) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.onload = () => {
      try {
        const jsonData = JSON.parse(fileReader.result);

        if (jsonData.status < 200 || jsonData.status >= 300) {
          reject(
            new ServiceError(
              jsonData,
              jsonData.error || "error",
              jsonData.status,
              jsonData.data
            )
          );
        } else {
          resolve(jsonData);
        }
      } catch (e) {
        resolve(blob);
      }
    };

    fileReader.onerror = (e) => {
      reject(new ServiceError(e, "Fail to read file.", 500));
    };

    fileReader.readAsText(blob);
  });
};

service.interceptors.response.use(
  (response) => {
    if (response.config.responseType === "blob") {
      return handleFileDownload(response.data).then((data) => {
        if (!(data instanceof Blob)) {
          return data;
        }
        return response;
      });
    }

    const responseData = response.data;
    if (responseData.status < 200 || responseData.status >= 300) {
      throw new ServiceError(
        responseData,
        responseData.error || "error",
        responseData.status,
        responseData.data
      );
    }

    return responseData;
  },
  async (error) => {
    const message = error.message || "error";
    console.error('zz', message, error);
    
    throw new ServiceError(
      error,
      message,
      error.response?.status,
      error.response?.data
    );
  }
);

export default service;
